module.exports = __webpack_public_path__ + "img/from-founders.da62b7dd.png";